<div *ngIf="loadingData" class="d-flex justify-content-center">
  <span class="spinner-grow spinner-grow-xl" role="status" aria-hidden="true"></span>
  &nbsp;
  <span class="padding-top-3px">{{translate.instant('actions.loading')}}</span>
</div>
